import {
  StakeholderType,
  AustralianState,
  UploadedDocument,
  PropertyAddress,
  PropertyDetails,
  PropertyImageUrls,
  VendorBuyer,
} from '@urbanx/agx-ui-components';
import { FormType } from '@urbanx/agx.campaigns.client';

export interface SendFormSubmission {
  campaignId: string;
  formId: string;
  formType: FormType;
  state: AustralianState;
  digitalSignatureSubmission: DigitalSignatureSubmission;
  documents?: UploadedDocument[];
}

export interface DigitalSignatureSubmission {
  vendorDetails?: DigitalSignatureClientDetails;
  buyerDetails?: DigitalSignatureClientDetails;
  recipientDetails?: DigitalSignatureClientDetails;
  agentId?: string;
  agentName?: string;
  carbonCopies?: string[];
  signingOrderGroups?: StakeholderType[];
  includeSolicitorsInSalesAdvice?: boolean;
  sendVendorsNow: boolean;
  resendEnvelope?: boolean;
}

export interface DigitalSignatureClientDetails {
  emailOverrides: { [key: string]: string } | null;
  subject?: string;
  body?: string;
  name?: string;
  preferredName?: string;
  stakeholderType?: StakeholderType | null;
}

export interface CampaignUpdatedEvent {
  campaignId: string;
}

export interface FormSubmissionResult {
  campaignId?: string;
  formId?: string;
  blankContractIsLive: boolean;
  errors?: string[];
}

export enum DevContractSeedMode {
  None = 'None',
  BlankPrepared = 'BlankPrepared',
  ContractSubmitted = 'ContractSubmitted',
}

export enum DevContractSeedSource {
  RPDataSearch = 'RPDataSearch',
  ManualAddress = 'ManualAddress',
}

export enum DevContractCreationSource {
  AgentPortal = 'AgentPortal',
  UploadedManually = 'UploadedManually',
}

export enum DevAgreementSource {
  DocuSign = 'DocuSign',
  UploadedManually = 'UploadedManually',
}

export enum DevListingLaunch {
  OffMarket = 'OffMarket',
  LaunchScheduled = 'LaunchScheduled',
}

export enum DevDepositProfile {
  Standard = 'Standard',
  ExceedsTenPercent = 'ExceedsTenPercent',
  EarlyRelease = 'EarlyRelease',
}

export enum DevContractConditions {
  None = 'None',
  Finance = 'Finance',
  BuildingAndPest = 'BuildingAndPest',
  BodyCorporate = 'BodyCorporate',
  CoolingOff = 'CoolingOff',
  SeveralSpecialConditions = 'SeveralSpecialConditions',
}

export enum DevContractStage {
  NewContract = 'NewContract',
  Accepted = 'Accepted',
  Unconditional = 'Unconditional',
}

export interface DevCreateContractTestCampaignRequest {
  agencyId?: string;
  createFrom: DevContractSeedSource;
  state: AustralianState;
  propertyAddress: PropertyAddress;
  propertyDetails?: PropertyDetails;
  propertyImageUrls?: PropertyImageUrls;
  vendors?: VendorBuyer[];
  hasPool?: boolean;
  agreementSource: DevAgreementSource;
  agreementDocuSignSigned: boolean;
  listingLaunch: DevListingLaunch;
  contract: DevContractSeedMode;
  contractCreationSource: DevContractCreationSource;
  contractConditions: DevContractConditions;
  contractStage: DevContractStage;
  depositProfile: DevDepositProfile;
}

export interface DevCreateContractTestCampaignResponse {
  campaignId: string;
  agencyId: string;
  agreementFormId: string;
  contractId?: string | null;
}
